<template>
  <container>
    <row>
      <column md="8" class="mx-auto">
        <jumbotron class="mt-5">
          <h1><Fa icon="code" class="grey-text" /> Sections</h1>
          <h6 class="my-3">INTROS</h6>
          <list-group>
            <!-- FREE -->
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/app">
              <h5 class="justify-content-between d-flex align-items-center">
                App intro <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/contactform">
              <h5 class="justify-content-between d-flex align-items-center">
                Contact Form intro  <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/classic">
              <h5 class="justify-content-between d-flex align-items-center">
                Classic Register Form intro <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/video">
              <h5 class="justify-content-between d-flex align-items-center">
                Video Background intro <fa icon="angle-right"/>
              </h5>
            </navbar-item>
          </list-group>
          <!-- PRO -->
          <h6 class="my-3">SECTIONS</h6>
          <list-group>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/contact">
              <h5 class="justify-content-between d-flex align-items-center">
                Contact <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/blog">
              <h5 class="justify-content-between d-flex align-items-center">
                Blog <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/e-commerce">
              <h5 class="justify-content-between d-flex align-items-center">
                E-commerce <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/features">
              <h5 class="justify-content-between d-flex align-items-center">
                Features <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/magazine">
              <h5 class="justify-content-between d-flex align-items-center">
                Magazine <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/projects">
              <h5 class="justify-content-between d-flex align-items-center">
                Projects <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/social">
              <h5 class="justify-content-between d-flex align-items-center">
                Social <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/team">
              <h5 class="justify-content-between d-flex align-items-center">
                Team <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/testimonials">
              <h5 class="justify-content-between d-flex align-items-center">
                Testimonials <fa icon="angle-right"/>
              </h5>
            </navbar-item>
            <navbar-item class="list-group-item list-group-item-action" router href="/sections/testimonials-multi">
              <h5 class="justify-content-between d-flex align-items-center">
                Testimonials Multi Item<fa icon="angle-right"/>
              </h5>
            </navbar-item>
          </list-group>
        </jumbotron>
      </column>
    </row>
  </container>
</template>

<script>
import { Container, Row, Column, Fa, Jumbotron, NavbarItem, ListGroup } from 'mdbvue';

export default {
  name: 'SectionsPage',
  components: {
    Container,
    Row,
    Column,
    Fa,
    Jumbotron,
    NavbarItem,
    ListGroup
  }
};
</script>

<style scoped>
.example-components-list {
  padding-top: 20px;
}

.example-components-list li {
  padding: 10px;
  background-color: white;
  border-bottom: 1px solid #f7f7f7;
  transition: .3s;
}

.example-components-list h6 {
  padding: 20px 10px 5px 10px;
  color: grey;
}

.example-components-list li:hover {
  background-color: #fafafa;
}

.example-components-list i {
  float: right;
  padding-top: 3px;
}

.nav-link.navbar-link h5 {
  color: #212529;
}
</style>
